// Custom CSS for Shopify Inbox chat (shadow DOM)
document.addEventListener('DOMContentLoaded', () => {
  const CSS_RULE = `
    button.chat-toggle { height: 40px; width: 40px; }
    button.chat-toggle.chat-toggle--icon-button.icon-only svg,
    button.chat-toggle.chat-toggle--icon-button.mobile-only svg { height: 35px; }
    button.chat-toggle.chat-toggle--text-button { height: 50px; }
    .chat-app .chat-app--close-button { height: 45px; width: 45px; }
    button.chat-toggle svg { height: 40px; }
    button.chat-toggle .chat-title { font-size: 20px; }
  `.trim();

  const STYLE_ID = 'custom-shopify-chat-css';

  function getShadowHost() {
    return document.querySelector('inbox-online-store-chat') || document.querySelector('#ShopifyChat');
  }

  function injectStyle(shadowRoot) {
    if (!shadowRoot || shadowRoot.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS_RULE;
    shadowRoot.appendChild(style);
  }

  function tryApply() {
    const host = getShadowHost();
    if (host?.shadowRoot) {
      injectStyle(host.shadowRoot);
      return true;
    }
    return false;
  }

  // initial
  tryApply();

  // keep watching in case widget mounts later or re-renders
  const observer = new MutationObserver(() => {
    tryApply();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  // fallback: sometimes shadowRoot attaches late
  const start = Date.now();
  const timer = setInterval(() => {
    if (tryApply() || Date.now() - start > 10000) {
      clearInterval(timer);
    }
  }, 200);
});
